import { Stack } from '@mui/material';
import { useDispatch } from 'react-redux';
import MenuBox from '@shared/components/MenuBox';
import { useUserDataQuery } from '../queries';
import { toggleDrawer } from '@libs/redux/appUiSlice';
import { useAppSelector } from '@libs/redux/store';
import SearchBar from '@shared/components/SearchBar';
import NewsDialog from '@shared/components/NewsDialog';
import { useAuthContext } from '@shared/auth/AuthContext';
import { TutorialDialog } from '../../features/tutorial/tutorial';
import AppTheme from '@libs/mui/AppTheme';
import DemoTopBarBanner from '@features/demo/components/DemoTopBarBanner';
import { AppLogo } from '@shared/components/AppLogo';
import { TopBarFilterButtonsStack } from '@shared/components/TopBarFilterButton';

const TopBar = () => {
  const dispatch = useDispatch();
  const isSearchActive = useAppSelector(state => state.appUi.isSearchActive);
  const { data: userData } = useUserDataQuery();
  const { isDemo } = useAuthContext();
  const colorScheme = userData?.colorScheme ?? AppTheme.palette.primary.main;

  return (
    <>
      {isDemo && <DemoTopBarBanner />}
      <Stack
        spacing={isSearchActive ? 0 : 1}
        sx={{
          height: isSearchActive ? 130 : 100,
          px: 2,
          py: 1,
          pb: isSearchActive ? 0.5 : 1,
          position: 'sticky',
          top: 0,
          overflow: 'hidden',
          transition: 'height 0.3s ease, padding-bottom 0.7s ease',
          background: colorScheme,
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <AppLogo
            sx={{
              transform: isSearchActive ? 'translateY(-120%)' : 'translateY(0)',
              transition: 'transform 0.5s ease-in-out',
            }}
          />
          {!isSearchActive && (
            <>
              <TutorialDialog />
              <NewsDialog />
            </>
          )}
        </Stack>

        <Stack spacing={4}>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{
              transform: isSearchActive ? 'translateY(-70%)' : 'translateY(0)',
              transition: 'transform 0.5s ease-in-out',
              position: 'relative',
              maxWidth: isSearchActive ? '90%' : '100%',
            }}
          >
            <SearchBar />
            {!isSearchActive && (
              <MenuBox id="menu-box-toggle-drawer" onClick={() => dispatch(toggleDrawer())} />
            )}
          </Stack>
        </Stack>
        {isSearchActive && <TopBarFilterButtonsStack sx={{ mt: 0.5 }} />}
      </Stack>
    </>
  );
};

export default TopBar;
